// Local dev license — this directory is gitignored, never committed.
export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjgzOGI5MTE2LTU4ZGEtNDBmZC1iZTUxLTJiNWE0ODRlZDgxZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.pK4rN7b8tMkfDnAW09PXW4Fh33OfDYcwz4ykEQiwneq+Lt2pL9qboGgfPq3DRANRcxH791JHYYxn+U5NC5Kh0w0L5WVUzE6lj8oyDQj1Iy+C9QBsdHen/PWD264paF3LAc5r3A==';
